"use strict";

exports.__esModule = true;
exports.default = void 0;
var _helpers = require("../../helpers");
var _WebRequestHelper = require("../../helpers/WebRequestHelper");
var _TranslationHelper = require("../../helpers/TranslationHelper");
var _actionTypes = require("./actionTypes");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class Actions extends _helpers.ActionHelper {
  constructor() {
    super({
      singular: 'optinentry',
      plural: 'optinentries'
    });
    _defineProperty(this, "getMyOptins", (useAuthentication = true) => {
      let optinsData;
      return dispatch => {
        return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
          request.method = 'get';
          request.url = `/optin`;
          return (0, _WebRequestHelper.sendRequest)(request).then(response => {
            optinsData = Object.assign({}, response);
            if (optinsData.data.length === 0) {
              dispatch({
                type: _actionTypes.GET_MY_OPTINS_SUCCESS,
                data: optinsData.data
              });
              return optinsData.data;
            }
            return (0, _TranslationHelper.translateOptins)('en-US', optinsData.data).then(optinsDataTranslated => {
              if (optinsDataTranslated.status === 200) {
                for (let i = 0; i < optinsData.data.length; i++) {
                  for (let j = 0; j < optinsDataTranslated.data.length; j++) {
                    if (optinsData.data[i].TitleTranslationId === optinsDataTranslated.data[j].SortKey) {
                      optinsData.data[i].TitleDisplayText = optinsDataTranslated.data[j].Value;
                    }
                    if (optinsData.data[i].TextTranslationId === optinsDataTranslated.data[j].SortKey) {
                      optinsData.data[i].TextDisplayText = optinsDataTranslated.data[j].Value;
                    }
                  }
                  if (!optinsData.data[i].TitleDisplayText) {
                    optinsData.data[i].TitleDisplayText = optinsData.data[i].Title;
                  }
                  if (!optinsData.data[i].TextDisplayText) {
                    optinsData.data[i].TextDisplayText = optinsData.data[i].Text;
                  }
                }
              }
              dispatch({
                type: _actionTypes.GET_MY_OPTINS_SUCCESS,
                data: optinsData.data
              });
              return optinsData.data;
            }).catch(err => {
              dispatch({
                type: _actionTypes.GET_MY_OPTINS_SUCCESS,
                data: optinsData.data
              });
              return optinsData.data;
            });
          }).catch(err => console.log(err));
        }).catch(err => console.log(err));
      };
    });
    _defineProperty(this, "acceptMyOptin", (body, useAuthentication = true) => {
      return dispatch => {
        return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
          request.method = 'POST';
          request.url = `/optin`;
          request.data = [body];
          return (0, _WebRequestHelper.sendRequest)(request).then(response => {
            dispatch({
              type: _actionTypes.ACCEPT_OPTIN_SUCCESS,
              data: body
            });
            return response.data;
          }).catch(err => console.log(err));
        }).catch(err => console.log(err));
      };
    });
  }
}
const actions = new Actions();
var _default = exports.default = actions;
module.exports = exports.default;